import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, ListGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';

/**
 * Modal Filtrar Títulos — duas listas (Disponíveis / Selecionados) + radio IN/NOT_IN.
 * Props:
 *   aberto: boolean
 *   onConfirmar: ({modo, lista}) => void
 *   onCancelar: () => void
 *   titulosDisponiveis: string[]
 *   selecionadosInicial: string[]
 *   modoInicial: 'IN' | 'NOT_IN'
 */
const ModalFiltrarTitulos = ({
  aberto,
  onConfirmar,
  onCancelar,
  titulosDisponiveis,
  selecionadosInicial,
  modoInicial,
}) => {
  const [disponiveis, setDisponiveis] = useState([]);
  const [selecionados, setSelecionados] = useState([]);
  const [modo, setModo] = useState('IN');
  const [itemDispSel, setItemDispSel] = useState(null);
  const [itemSelSel, setItemSelSel] = useState(null);

  useEffect(() => {
    if (aberto) {
      const sels = selecionadosInicial || [];
      const disps = (titulosDisponiveis || []).filter((t) => !sels.includes(t));
      setDisponiveis(disps);
      setSelecionados(sels);
      setModo(modoInicial || 'IN');
      setItemDispSel(null);
      setItemSelSel(null);
    }
  }, [aberto, titulosDisponiveis, selecionadosInicial, modoInicial]);

  const moverParaSelecionados = () => {
    if (!itemDispSel) return;
    setDisponiveis((prev) => prev.filter((t) => t !== itemDispSel));
    setSelecionados((prev) => [...prev, itemDispSel]);
    setItemDispSel(null);
  };

  const moverParaDisponiveis = () => {
    if (!itemSelSel) return;
    setSelecionados((prev) => prev.filter((t) => t !== itemSelSel));
    setDisponiveis((prev) => [...prev, itemSelSel]);
    setItemSelSel(null);
  };

  const incluirTodos = () => {
    setSelecionados((prev) => [...prev, ...disponiveis]);
    setDisponiveis([]);
    setItemDispSel(null);
  };

  const excluirTodos = () => {
    setDisponiveis((prev) => [...prev, ...selecionados]);
    setSelecionados([]);
    setItemSelSel(null);
  };

  const handleConfirmar = () => {
    if (selecionados.length === 0) {
      toast.warn('Nenhum título escolhido');
      return;
    }
    onConfirmar({ modo, lista: selecionados });
  };

  return (
    <Modal show={aberto} onHide={onCancelar} size="lg" centered>
      <Modal.Header style={{ background: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: 16 }}>Filtrar Títulos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-2">
          <Col md={5}>
            <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Disponíveis</Form.Label>
            <ListGroup style={{ maxHeight: 300, overflowY: 'auto', fontSize: 13 }}>
              {disponiveis.map((t) => (
                <ListGroup.Item
                  key={t}
                  action
                  active={itemDispSel === t}
                  onClick={() => setItemDispSel(t)}
                  onDoubleClick={() => { setItemDispSel(t); moverParaSelecionados(); }}
                  style={{ padding: '4px 8px' }}
                >
                  {t}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
          <Col md={2} className="d-flex flex-column justify-content-center align-items-center" style={{ gap: 8 }}>
            <Button size="sm" variant="outline-primary" onClick={moverParaSelecionados} title="Incluir selecionado">&gt;</Button>
            <Button size="sm" variant="outline-primary" onClick={incluirTodos} title="Incluir todos">&gt;&gt;</Button>
            <Button size="sm" variant="outline-secondary" onClick={moverParaDisponiveis} title="Excluir selecionado">&lt;</Button>
            <Button size="sm" variant="outline-secondary" onClick={excluirTodos} title="Excluir todos">&lt;&lt;</Button>
          </Col>
          <Col md={5}>
            <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Selecionados</Form.Label>
            <ListGroup style={{ maxHeight: 300, overflowY: 'auto', fontSize: 13 }}>
              {selecionados.map((t) => (
                <ListGroup.Item
                  key={t}
                  action
                  active={itemSelSel === t}
                  onClick={() => setItemSelSel(t)}
                  onDoubleClick={() => { setItemSelSel(t); moverParaDisponiveis(); }}
                  style={{ padding: '4px 8px' }}
                >
                  {t}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Check
              inline
              type="radio"
              label="Só as selecionadas"
              name="modoFiltroTitulos"
              value="IN"
              checked={modo === 'IN'}
              onChange={() => setModo('IN')}
            />
            <Form.Check
              inline
              type="radio"
              label="Exceto as selecionadas"
              name="modoFiltroTitulos"
              value="NOT_IN"
              checked={modo === 'NOT_IN'}
              onChange={() => setModo('NOT_IN')}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onCancelar}>Cancelar</Button>
        <Button variant="primary" size="sm" onClick={handleConfirmar}>OK</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalFiltrarTitulos;
